import { render, staticRenderFns } from "./tabs-pane.vue?vue&type=template&id=434f8367&scoped=true&"
import script from "./tabs-pane.vue?vue&type=script&lang=js&"
export * from "./tabs-pane.vue?vue&type=script&lang=js&"
import style0 from "./tabs-pane.vue?vue&type=style&index=0&id=434f8367&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "434f8367",
  null
  
)

export default component.exports